import React from 'react';

import BEM from '@scripts/utilities/bem.js';
import { currencyFormatter } from '@scripts/utilities/numbers.js';

import DonutChart from '../../DonutChart/index.jsx';


class AssetBreakdown extends React.Component {
  constructor(props) {
    super(props);

    this.labelFormatter = this.labelFormatter.bind(this);
    this.tooltipFormatter = this.tooltipFormatter.bind(this);
    this.setChartOptions = this.setChartOptions.bind(this);
  }

  labelFormatter(params) {
    var result = params.name;

    for (var i = 0; i < this.props.portfolio.length; i++) {
      var portfolioItem = this.props.portfolio[i];

      if (portfolioItem.asset.id == params.name) {
        result = portfolioItem.asset.ticker.toUpperCase();
        break;
      }
    }

    return result;
  }

  portfolioToChartData(item) {
    return {
      name: item.asset.id,
      value: item.value
    };
  }

  tooltipFormatter(params) {
    var assetName = params.name;

    for (var i = 0; i < this.props.portfolio.length; i++) {
      var portfolioItem = this.props.portfolio[i];

      if (portfolioItem.asset.id == params.name) {
        assetName = portfolioItem.asset.title;
        break;
      }
    }

    return assetName + ': <strong>' + currencyFormatter.format(params.value) +
      '</strong> (' + params.percent + '%)';
  }

  setChartOptions(options) {
    options.tooltip.formatter = this.tooltipFormatter;

    options.series[0].label = {
      show: true,
      formatter: this.labelFormatter,
      position: 'inside',
      fontWeight: 'bold'
    };
    options.series[0].labelLine = { show: true };

    return options;
  }

  render() {
    var content = null;

    if (this.props.portfolio) {
      var chartData = this.props.portfolio.map(this.portfolioToChartData);

      if (chartData.length) {
        content = (
          <React.Fragment>
            <div className={BEM.classString('cs-block-asset-chart', 'align-narrow') + ' mb-2'}>
              <DonutChart
                chartData={chartData}
                showLegend={false}
                setChartOptions={this.setChartOptions}
              />
            </div>
            <p className="text-center"><strong>Breakdown by Held Value (USD)</strong></p>
          </React.Fragment>
        );
      }
    }


    return content;
  }
}


export default AssetBreakdown;

